/* Chapter navigation for buying guides.

   Three jobs: pin the bar below the theme header, hold its place while pinned,
   and highlight the chapter the reader is actually in.

   WHY NOT position: sticky
   The nav is a direct child of .article-editorial, which is display: grid. A
   grid item's containing block is its own grid area — here a single auto-height
   row exactly as tall as the nav — and a sticky element cannot travel outside
   that rectangle. `position: sticky; top: 0` would have a scroll range of zero
   and quietly do nothing. So the pinning is done here instead.

   Dependency-free on purpose: it ships as a theme asset, and the whole file
   costs less than a framework spends booting.

   Degrades honestly. With JS off the bar scrolls away with the page and every
   link still jumps to its heading; only pinning and highlighting are lost. */
(function () {
  'use strict';

  var nav = document.querySelector('.tdt-chapters');
  if (!nav) return;

  var box = nav.querySelector('.tdt-chapters__inner');
  var links = Array.prototype.slice.call(nav.querySelectorAll('a'));
  if (!links.length || !box) return;

  var targets = links.map(function (a) {
    try {
      return document.querySelector(a.getAttribute('href'));
    } catch (e) {
      return null;
    }
  });

  /* Reserves the space the bar vacates when it goes fixed, so the article does
     not jump upward by the bar's height at the moment it pins. */
  var spacer = document.createElement('div');
  spacer.className = 'tdt-chapters-spacer';
  nav.parentNode.insertBefore(spacer, nav.nextSibling);

  /* The theme header is sticky and its height changes between breakpoints and
     when the announcement bar is dismissed, so measure rather than hard-code.
     Only counts it while it is actually pinned to the top. */
  function headerHeight() {
    var h = document.querySelector(
      'sticky-header, .shopify-section-header-sticky, .section-header .header-wrapper'
    );
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.top <= 1 && r.height ? r.height : 0;
  }

  var stuck = false;
  var active = -1;
  var flowHeight = 0;

  /* The bar carries vertical margin in normal flow, and going fixed takes the
     margins out of the flow along with the box. offsetHeight excludes them, so
     a spacer sized from offsetHeight alone would drop 7.2rem and the article
     would jump upward at the moment of pinning. Measure the full flow height —
     box plus margins — and only while the bar is unpinned, since the pinned
     rule zeroes the margins. */
  function measureFlowHeight() {
    var cs = window.getComputedStyle(nav);
    flowHeight =
      nav.offsetHeight + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
  }

  function update() {
    var headH = headerHeight();
    document.documentElement.style.setProperty('--tdt-header-h', headH + 'px');

    /* Measure the bar's resting position from the spacer, which stays in flow
       whether the bar is pinned or not. Measuring the nav itself would read its
       fixed position once pinned and immediately unpin it. */
    if (!stuck) measureFlowHeight();

    var restTop = spacer.getBoundingClientRect().top + window.scrollY;
    if (stuck) restTop -= flowHeight;

    var shouldStick = window.scrollY + headH >= restTop;

    if (shouldStick !== stuck) {
      stuck = shouldStick;
      if (stuck) {
        spacer.style.height = flowHeight + 'px';
        nav.classList.add('is-stuck');
      } else {
        nav.classList.remove('is-stuck');
        spacer.style.height = '0px';
      }
    }

    spy(headH);
  }

  function spy(headH) {
    /* A heading is current once it passes below the sticky furniture. Walking
       forward and keeping the last match shows the section the reader is
       inside, not the one arriving. */
    var line = headH + nav.offsetHeight + 24;
    var current = 0;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i] && targets[i].getBoundingClientRect().top <= line) current = i;
    }

    /* At the very bottom the last heading may be too close to the end to ever
       cross the line, so a reader who scrolls to the finish would never see it
       highlighted. */
    if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
      current = targets.length - 1;
    }

    if (current === active) return;
    if (active > -1) links[active].classList.remove('is-active');
    links[current].classList.add('is-active');
    active = current;

    /* Keep the active chapter visible in the scroller — otherwise a reader ten
       chapters deep is looking at a bar still showing chapter one. */
    if (box.scrollWidth > box.clientWidth) {
      var a = links[current];
      box.scrollTo({
        left: Math.max(0, a.offsetLeft - box.clientWidth / 2 + a.offsetWidth / 2),
        behavior: 'smooth'
      });
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      update();
      ticking = false;
    });
  }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    /* Unpin before measuring, so restTop is read from a bar in normal flow. */
    if (stuck) {
      nav.classList.remove('is-stuck');
      spacer.style.height = '0px';
      stuck = false;
    }
    update();
  });
})();
